angular.module('storefrontApp')
    .component('vcCheckoutCoupon', {
        templateUrl: 'themes/assets/js/checkout/checkout-coupon.tpl.liquid',
        bindings: {
            coupons: '=',
            onApplyCoupon: '&',
            onRemoveCoupon: '&',
            onValidateCoupon: '&',
        },
        controller: ['$scope', function ($scope) {
            const ctrl = this;

            ctrl.coupon = { appliedSuccessfully: true };

            $scope.$watch('$ctrl.coupon', function () {
                if (!ctrl.coupon.code) {
                    ctrl.coupon.appliedSuccessfully = true;
                    delete ctrl.coupon.errorCode;
                }
            }, true);

            $scope.$on('cartItemsChanged', function () {
                delete ctrl.coupon.errorCode;
            });

            ctrl.applyCoupon = function (coupon) {
                ctrl.onValidateCoupon({ coupon })
                    .then(function (result) {
                        if (result.appliedSuccessfully) {
                            ctrl.onApplyCoupon({ coupon });
                            ctrl.coupon = {};
                        }
                    });
            };

            ctrl.removeCoupon = function (coupon) {
                ctrl.onRemoveCoupon({ coupon });
            };
        }],
    });
